import React from 'react'
import PropTypes from 'prop-types'
import { FieldLabel, TextField } from 't3-widgets'

import { getTooltip } from '../../../../../common/operations'

const LicensePlateField = ({ error, intl, onChange, onFocus, validator, value }) => {
    return (
        <FieldLabel
            id="license-plate-field-label"
            label={intl.translate('ap_step3_licenseplate_label')}
            tooltip={getTooltip(
                intl.translate('ap_step3_licenseplate_label'),
                intl.translate('ap_step3_licenseplate_hint')
            )}
        >
            <TextField
                id="license-plate-field"
                placeholder=""
                value={value}
                error={error}
                onChange={onChange}
                onBlur={validator}
                onFocus={onFocus}
            />
        </FieldLabel>
    )
}

LicensePlateField.propTypes = {
    error: PropTypes.string,
    intl: PropTypes.objectOf(PropTypes.func),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    validator: PropTypes.func,
    value: PropTypes.string
}

export { LicensePlateField }
